<template>
    <b-btn v-if="isAvailable" :to="{ name: link, params: { id: purchase.id } }" class="btn-card-action btn-card-action-green my-1">Редактировать</b-btn>
</template>

<script>
export default {
    name: 'cabinet-fl44-notice-card-edit-button',
    props: {
        purchase: {
            type: Object,
            required: true
        }
    },
    computed: {
        isAvailable() {
            return this.purchase.actions.edit;
        },
        link() {
            return this.purchase.type === 'fl44' ? 'Fl44PurchaseEdit' : 'Fl44UnknownVolumePurchaseEdit';
        }
    }
};
</script>
